import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../lib/services/dashboard/dashboard.service';
import { Contracts, SingleContract } from '../../lib/models/contracts';
import { PaymentLiberationService } from '../../lib/services/payment-liberation/payment-liberation.service';
import { SystemAuthenticationService } from '@monex-sistemas/nueva-banca-digital-library'
import * as pubsub from "pubsub-js";
import { firstValueFrom } from 'rxjs';
import { CheckTokenStatusService } from '../../lib/services/tokenstatus/check-token-status.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../lib/services/toast/toast.service';
import { ModalsService } from '../../lib/services/modals/modals.service';
import { SystemConfigurationService } from '../../lib/services/system-configuration/system-configuration.service';
import { StorageKeysEnum } from '../../lib/storage/storage-keys.enum';


const pubsubEvent = "[payment release event] - update payment relase active contracts"
@Component({
  selector: 'app-payment-liberation',
  templateUrl: './payment-liberation.component.html',
  styleUrls: ['./payment-liberation.component.scss']
})
export class PaymentLiberationComponent implements OnInit, OnDestroy {
  showXIcon: boolean = false;
  ngbModalRef: NgbModalRef;
  contracts: SingleContract[] = [];
  selectedContracts: { idContrato: number, activo: boolean }[] = []
  contractsWithPaymentReleased: { contractId: number, active: boolean }[] = []
  translations: any
  loadingPaymentsRelease: boolean = false;
  arrContractsFacMan : String[] = [];
  contractsFacMan : String = "";
  contractsReleasePayment: SingleContract[] = [];
  constructor(
    private dashboarService: DashboardService,
    private paymentLiberationService: PaymentLiberationService,
    private systemAuthService: SystemAuthenticationService,
    private tokenStatusService: CheckTokenStatusService,
    private translationService: TranslateService,
    private toastService: ToastService,
    private modalsService: ModalsService,
  ) {
    this.contracts = dashboarService.getContracts().contracts
  }

  async ngOnInit(): Promise<void> {
    pubsub.subscribe(pubsubEvent, async (msg: any, data: any) => {
      let tokenStatus
      let updateStatus
      this.systemAuthService.showLoading()
      try {
        tokenStatus = await this.tokenStatusService.checkTokenStatus(this.translations.TOKEN_STATUS, data.modalRef)
        this.systemAuthService.hideLoading()
      } catch (error) {
        console.log(error)
        this.toastService.showToast()
        this.systemAuthService.hideLoading()
        return
      }

      if (tokenStatus) {
        updateStatus = await this.updatePaymentRelease(data?.token);
        if (!updateStatus) {
          this.toastService.showToast(this.translations.ERROR_UPDATE_PAYMENT_RELEASE)
          return
        }
        this.ngbModalRef.close();
        this.modalsService.open([], 'success', true, true, this.translations.PAYMENT_RELEASE_SUCCESS_MODAL, '', '', 'md')
        return
      }
    })


    await this.getTranslation()
    await this.getAllRealeasePayment();
    await this.validateContractsReleasePayments();
    this.setContractsActiveOption();

    this.contractsFacMan = sessionStorage.getItem(StorageKeysEnum.CONTRACTS_FACMAN)+"";
    this.arrContractsFacMan = this.contractsFacMan.split(",");
  }

  async closeModal() {
    await this.getAllRealeasePayment()
    this.setContractsActiveOption()
    this.ngbModalRef.close()
  }

  async getTranslation() {
    this.translations = await firstValueFrom(this.translationService.get([
      "PAYMENT_RELEASE_SUCCESS_MODAL",
      "WARNING",
      "NO_CHANGES_PAYMENT_RELEASE",
      "ERROR_UPDATE_PAYMENT_RELEASE",
      "TOKEN_STATUS"
    ]))
  }

  async getAllRealeasePayment() {
    this.loadingPaymentsRelease = true
    try {
      this.contractsWithPaymentReleased = await firstValueFrom(this.paymentLiberationService.getAllPaymentRelease());
      this.loadingPaymentsRelease = false
    } catch (error) {
      console.log(error);
      this.loadingPaymentsRelease = false
      return
    }
  }

  setContractsActiveOption() {  
    this.contractsReleasePayment.forEach(x => {
      this.contractsWithPaymentReleased.forEach(y => {
        if (x.contractId == y.contractId) {
          x.active = y.active
        }
      })
    })
  }

  addPaymentReleaseContract(contract, event) {
    const existingContract = this.selectedContracts.findIndex(item => item.idContrato === contract.contractId)
    if (existingContract == -1) {
      contract.active = event.target.checked
      this.selectedContracts.push({ idContrato: contract.contractId, activo: contract.active })

    } else {
      this.selectedContracts.forEach(x => {
        if (x.idContrato == contract.contractId) {
          x.activo == !x.activo
        }
      })
    }
  }

  async updatePaymentRelease(otpToken: string) {
    try {
      await firstValueFrom(this.paymentLiberationService.updatePaymentRelease(this.selectedContracts, otpToken))
    } catch (error) {
      console.log(error)
      return false
    }
    return true
  }

  openSystemAuth() {
    if (!this.selectedContracts || this.selectedContracts.length <= 0) {
      this.toastService.showToast(this.translations.NO_CHANGES_PAYMENT_RELEASE, "warn", this.translations.WARNING)
      return
    }
    this.systemAuthService.openValidationToken(pubsubEvent)
  }

  ngOnDestroy(): void {
    pubsub.unsubscribe(pubsubEvent)
  }

  validateContractFacman(contractId : Number): boolean {
    let res = false;
    this.arrContractsFacMan.forEach(x => {
      if (x == contractId+"") {
        res = true;
      }
    })
    return res;

  }

  async validateContractsReleasePayments() {
    this.contracts.forEach(x => {
      this.contractsWithPaymentReleased.forEach(y => {
        if (x.contractId == y.contractId) {
          this.contractsReleasePayment.push(x);
        }
      })
    })
  }
}
